export default "__VITE_ASSET__d878cacb__"